import SocialExploreRoutes from './SocialExploreRoutes';

export default SocialExploreRoutes;
